module.exports = __webpack_public_path__ + "fonts/seguili.5989bb88.ttf";